import { Component, OnInit } from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {WhmcsClient, WhmcsClientDetails} from '../../models/whmcs-client.model';
import {MatSnackBar} from '@angular/material/snack-bar';
import {MatDialog} from '@angular/material/dialog';
import {WhmcsService} from '../../services/whmcs-service';
import {DialogQuickSmsComponent} from './dialogs/dialog-quick-sms/dialog-quick-sms.component';
import {DialogClientDetailsComponent} from './dialogs/dialog-client-details/dialog-client-details.component';
import {DialogErrorComponent} from '../../dialogs/dialog-error/dialog-error.component';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';

@Component({
  selector: 'app-streamup-whmcs',
  templateUrl: './whmcs.component.html',
  styleUrls: ['./whmcs.component.scss']
})
export class WhmcsComponent implements OnInit {

    loadingWhmcsClients$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
    hasClients$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    clients$: BehaviorSubject<WhmcsClient[]> = new BehaviorSubject<WhmcsClient[]>([]);
    clientSettingsForm: FormGroup;

    statuses = [
        {value: '1', viewValue: 'Active'},
        {value: '0', viewValue: 'Inactive'},
        {value: '-1', viewValue: 'Both'}
    ];

  constructor(
      private whmcsService: WhmcsService,
      private formBuilder: FormBuilder,
      public snackBar: MatSnackBar,
      private dialog: MatDialog,
  ) { }

  ngOnInit(): void {
      this.createForm();
      this.getWhmcsClients();
  }

    createForm() {
        this.clientSettingsForm = this.formBuilder.group({
            clientStatus: ['1'],
        });
    }

  getWhmcsClients(){
    this.loadingWhmcsClients$.next(true);
    this.whmcsService.getWhmcsClients(this.clientSettingsForm.value.clientStatus)
        .subscribe((clients: WhmcsClient[]) => {
          this.clients$.next(clients);
          this.hasClients$.next(clients.length > 0);
          this.loadingWhmcsClients$.next(false);
        });
  }

  syncWhmcsClients(){
      this.whmcsService.syncWhmcsClients()
          .subscribe((result: boolean | any) => {
                  if (result){
                      this.snackBar.open('Whmcs clients successfully synced!', null, {duration: 3000});
                      this.getWhmcsClients();
                  }else{
                      this.handleError('Could not sync Whmcs clients!');
                  }
              },
              (errorResponse: any) => {
                  this.handleError(errorResponse.error.message.information);
              });
  }

  getClientDetails(client: WhmcsClient){
      this.whmcsService.getWhmcsClientDetails(client.id)
          .subscribe((details: WhmcsClientDetails | any) => {
              if (details instanceof WhmcsClientDetails){
                  return this.dialog
                      .open(DialogClientDetailsComponent, {
                          data: {
                              basic: client,
                              extra: details
                          },
                          width: '600px',
                          role: 'dialog'
                      })
                      .afterClosed();
          }else{
                  this.handleError(details.information);
              }
          },
              (errorResponse: any) => {
                  this.handleError(errorResponse.error.message.information);
              });
  }

    getClientPhonenumberForSMS(client: WhmcsClient){
        this.whmcsService.getWhmcsClientDetails(client.id)
            .subscribe((details: WhmcsClientDetails | any) => {
                if (details instanceof WhmcsClientDetails) {
                    this.sendQuickSms(
                        client.lastname + ' ' + client.firstname,
                        details.phonecc + details.phonenumber);
                }else{
                    this.handleError(details.information);
                }
            },
                (errorResponse: any) => {
                    this.handleError(errorResponse.error.message.information);
                });
    }

  sendQuickSms(clientFullName: string, phoneNumber: string){
      return this.dialog
          .open(DialogQuickSmsComponent, {
              data: {
                  fullName: clientFullName,
                  phoneNumber: phoneNumber,
              },
              width: '500px',
              role: 'dialog'
          })
          .afterClosed()
          .subscribe(respCode => {
              switch (respCode) {
                  case -1: // Return button
                      break;
                  case 0: // Complete
                      this.snackBar.open('An error occurred!', null, {duration: 1000});
                      break;
                  case 1: // Complete
                      this.snackBar.open('SMS successfully sent!', null, {duration: 1000});
                      break;
              }
          });
  }

    handleError(errorInformation: string){
        return this.dialog
            .open(DialogErrorComponent, {
                data: {
                    error: errorInformation,
                },
                width: '600px',
                role: 'dialog'
            })
            .afterClosed()
            .subscribe();
    }

}
